import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'personalizations-legal-documents',
  storeModule.createStoreModule('personalizations-legal-documents')
)
